// extracted by mini-css-extract-plugin
export var errorsContainer = "_tg-1";
export var link = "_tg-0";